
import './Loader.css';
import Img from "../../assets/img/brand/Metaqualt_icon1.gif"
const Loader = () => (

    <div className="vp-loader">
      <img src={Img} alt="" />
    </div>

);

export default Loader;